export const MANUFACTURER_GROUPS = {
  MEVOTECH: [
    {
      manufacturer: "MEVOTECH ORIGINAL GRADE INTL.",
      manufacturerImageLogoUrl: "https://partsavatar.ca/images/manufacturers/MEVOTECH ORIGINAL GRADE INTL._small.png",
      url: "/mevotech-original-grade-intl",
    },
    {
      manufacturer: "MEVOTECH ORIGINAL GRADE",
      manufacturerImageLogoUrl: "/cms/mevotech/images/mevotech-original-grade-logo.webp",
      url: "/mevotech-original-grade",
    },
    {
      manufacturer: "MEVOTECH TTX",
      manufacturerImageLogoUrl: "/cms/mevotech/images/mevotech-ttx-logo.webp",
      url: "/mevotech-ttx",
    },
  ],
  "BLUE STREAK": [
    {
      manufacturer: "BLUE STREAK ELECTRONICS",
      manufacturerImageLogoUrl: "/images/manufacturers/BLUE%20STREAK%20ELECTRONICS_small.png",
      url: "/blue-streak-electronics",
    },
    {
      manufacturer: "BLUE STREAK (HYGRADE MOTOR)",
      manufacturerImageLogoUrl: "/images/manufacturers/BLUE%20STREAK%20(HYGRADE%20MOTOR)_small.png",
      url: "/blue-streak-electronics",
    },
  ],
  CASTROL: [
    {
      manufacturer: "CASTROL SFX",
      manufacturerImageLogoUrl: "/cms/castrol/images/castrol-sfx.webp",
      url: "/castrol-sfx",
    },
  ],
  WALKER: [
    {
      manufacturer: "WALKER USA",
      manufacturerImageLogoUrl: "/images/manufacturers/WALKER%20USA_small.png",
      url: "/walker-usa",
    },
  ],
  DORMAN: [
    {
      manufacturer: "DORMAN PREMIUM",
      manufacturerImageLogoUrl: "/images/manufacturers/DORMAN%20PREMIUM_small.png",
      url: "/dorman-premium",
    },
    {
      manufacturer: " DORMAN (HD SOLUTIONS)",
      manufacturerImageLogoUrl: "/images/manufacturers/DORMAN%20(HD%20SOLUTIONS)_small.png",
      url: "/dorman-hd-solutions",
    },
    {
      manufacturer: " DORMAN/EZ DRAIN",
      manufacturerImageLogoUrl: "/images/manufacturers/DORMAN-EZ%20DRAIN_small.png",
      url: "/dorman-ez-drain",
    },
    {
      manufacturer: " DORMAN/CONDUCT-TITE",
      manufacturerImageLogoUrl: "/images/manufacturers/DORMAN-CONDUCT-TITE_small.png",
      url: "/dorman-conduct-tite",
    },
    {
      manufacturer: " DORMAN/AUTOGRADE",
      manufacturerImageLogoUrl: "/images/manufacturers/DORMAN-AUTOGRADE_small.png",
      url: "/dorman-autograde",
    },
    {
      manufacturer: " DORMAN/FIRST STOP",
      manufacturerImageLogoUrl: "/images/manufacturers/DORMAN-FIRST%20STOP_small.png",
      url: "/dorman-first-stop",
    },
    {
      manufacturer: " DORMAN/HELP",
      manufacturerImageLogoUrl: "/images/manufacturers/DORMAN-HELP_small.png",
      url: "/dorman-help",
    },
    {
      manufacturer: " MAS INDUSTRIES",
      manufacturerImageLogoUrl: "/images/manufacturers/MAS%20INDUSTRIES_small.png",
      url: "/mas-industries",
    },
    {
      manufacturer: " DORMAN (OE SOLUTIONS)",
      manufacturerImageLogoUrl: "/images/manufacturers/DORMAN%20(OE%20SOLUTIONS)_small.png",
      url: "/dorman-oe-solutions",
    },
    {
      manufacturer: " DORMAN/TECHOICE",
      manufacturerImageLogoUrl: "/images/manufacturers/DORMAN-TECHOICE_small.png",
      url: "/dorman-techoice",
    },
  ],
  "BBB INDUSTRIES": [
    {
      manufacturer: "BBB INDUSTRIES - PACE",
      manufacturerImageLogoUrl: "/cms/bbb-industries/images/bbb-industries-pace.webp",
      url: "/bbb-industries-pace",
    },
  ],
  "NGK CANADA": [
    {
      manufacturer: "NGK",
      manufacturerImageLogoUrl: "/images/manufacturers/NGK%20CANADA_small.png",
      url: "/ngk",
    },
    {
      manufacturer: "NGK USA",
      manufacturerImageLogoUrl: "/images/manufacturers/NGK%20USA_small.png",
      url: "/ngk-usa",
    },
  ],
  "CHAMPION PARTS": [
    {
      manufacturer: " CHAMPION SPARK PLUG",
      manufacturerImageLogoUrl: "/images/manufacturers/CHAMPION%20SPARK%20PLUG_small.png",
      url: "/champion-spark-plug",
    },
  ],
  "PHILLIPS & TEMRO": [
    {
      manufacturer: "ZEROSTART/TEMRO",
      manufacturerImageLogoUrl: "/images/manufacturers/ZEROSTART-TEMRO_small.png",
      url: "/zerostart-temro",
    },
  ],
  MONROE: [
    {
      manufacturer: "MONROE/EXPERT SERIES",
      manufacturerImageLogoUrl: "/images/manufacturers/MONROE-EXPERT%20SERIES_small.png",
      url: "/monroe-expert-series",
    },
    {
      manufacturer: "RIDE CONTROL/MONROE",
      manufacturerImageLogoUrl: "/cms/monroe/images/monroe-ride-control.webp",
      url: "/ride-control-monroe",
    },
  ],
  WORLDPARTS: [
    {
      manufacturer: "WORLDPARTS BRAKE CABLES",
      manufacturerImageLogoUrl: "/images/manufacturers/WORLDPARTS_small.png",
      url: "/worldparts-brake-cables",
    },
    {
      manufacturer: "WORLDPARTS BRAKE PADS",
      manufacturerImageLogoUrl: "/images/manufacturers/WORLDPARTS_small.png",
      url: "/worldparts-brake-pads",
    },
    {
      manufacturer: "WORLDPARTS WIRE SETS",
      manufacturerImageLogoUrl: "/images/manufacturers/WORLDPARTS_small.png",
      url: "/worldparts-wire-sets",
    },
    {
      manufacturer: "WORLDPARTS BRAKE ROTORS",
      manufacturerImageLogoUrl: "/images/manufacturers/WORLDPARTS_small.png",
      url: "/worldparts-brake-rotors",
    },
    {
      manufacturer: "WORLDPARTS CV AXLES",
      manufacturerImageLogoUrl: "/images/manufacturers/WORLDPARTS_small.png",
      url: "/worldparts-cv-axles",
    },
    {
      manufacturer: "WORLDPARTS HUB ASSEMBLIES",
      manufacturerImageLogoUrl: "/images/manufacturers/WORLDPARTS_small.png",
      url: "/worldparts-hub-assemblies",
    },
    {
      manufacturer: "WORLDPARTS WATER PUMPS",
      manufacturerImageLogoUrl: "/images/manufacturers/WORLDPARTS_small.png",
      url: "/worldparts-water-pumps",
    },
  ],
  ACDELCO: [
    {
      manufacturer: "ACDELCO PROFESSIONAL",
      manufacturerImageLogoUrl: "/images/manufacturers/ACDELCO%20PROFESSIONAL_small.png",
      url: "/acdelco-professional",
    },
  ],
  DAYCO: [
    {
      manufacturer: "DAYCO IMPORT",
      manufacturerImageLogoUrl: "/images/manufacturers/DAYCO%20IMPORT_small.png",
      url: "/dayco-import",
    },
  ],
  "EDGE PRODUCTS": [
    {
      manufacturer: "EDGE",
      manufacturerImageLogoUrl: "/images/manufacturers/EDGE%20PRODUCTS_small.png",
      url: "/edge",
    },
  ],
  FIRESTONE: [
    {
      manufacturer: "FIRESTONE RIDE-RITE",
      manufacturerImageLogoUrl: "/images/manufacturers/FIRESTONE%20RIDE-RITE_small.png",
      url: "/firestone-ride-rite",
    },
  ],
  "HELLA PAGID": [
    {
      manufacturer: "HELLA",
      manufacturerImageLogoUrl: "/images/manufacturers/HELLA_small.png",
      url: "/hella",
    },
  ],
  "LAKEWOOD INDUSTRIES": [
    {
      manufacturer: "LAKEWOOD",
      manufacturerImageLogoUrl: "/images/manufacturers/LAKEWOOD%20INDUSTRIES_small.png",
      url: "/lakewood",
    },
  ],
  "LUCAS OIL": [
    {
      manufacturer: "LUCAS OIL PRODUCTS INC.",
      manufacturerImageLogoUrl: "/images/manufacturers/LUCAS%20OIL%20PRODUCTS%20INC._small.png",
      url: "/lucas-oil-products-inc",
    },
  ],
  "PUTCO LIGHTING": [
    {
      manufacturer: "PUTCO",
      manufacturerImageLogoUrl: "/images/manufacturers/PUTCO_small.png",
      url: "/putco",
    },
  ],
  "ROYAL PURPLE FILTERS": [
    {
      manufacturer: "ROYAL PURPLE",
      manufacturerImageLogoUrl: "/images/manufacturers/ROYAL%20PURPLE%20FILTERS_small.png",
      url: "/royal-purple",
    },
  ],
  "TRAIL FX": [
    {
      manufacturer: "TRAILFX",
      manufacturerImageLogoUrl: "/cms/trail-fx/images/TrailFX-logo.webp",
      url: "/trailfx",
    },
  ],
  "ATP PROFESSIONAL AUTO PARTS": [
    {
      manufacturer: "ATP PROFESSIONAL AUTOPARTS",
      manufacturerImageLogoUrl: "/images/manufacturers/ATP%20PROFESSIONAL%20AUTOPARTS_small.png",
      url: "/atp-professional-autoparts",
    },
  ],
  "VICTOR REINZ": [
    {
      manufacturer: "VICTOR",
      manufacturerImageLogoUrl: "/images/manufacturers/VICTOR%20REINZ_small.png",
      url: "/victor",
    },
  ],
  "UNITY AUTOMOTIVE": [
    {
      manufacturer: "UNITY",
      manufacturerImageLogoUrl: "/images/manufacturers/UNITY%20AUTOMOTIVE_small.png",
      url: "/unity",
    },
  ],
  BANDO: [
    {
      manufacturer: "BANDO USA",
      manufacturerImageLogoUrl: "/images/manufacturers/BANDO_small.png",
      url: "/unity",
    },
  ],
  "GENIUS PREMIUM BRAKE PRODUCTS": [
    {
      manufacturer: "GENIUS",
      manufacturerImageLogoUrl: "/images/manufacturers/GENIUS_small.png",
      url: "/genius",
    },
  ],
  "KOBRA BELT": [
    {
      manufacturer: "KOBRA",
      manufacturerImageLogoUrl: "/images/manufacturers/KOBRA%20BELT_small.png",
      url: "/kobra",
    },
  ],
  "APEX AUTOMOBILE PARTS": [
    {
      manufacturer: "APEX GASKET",
      manufacturerImageLogoUrl: "/images/manufacturers/APEX%20AUTOMOBILE%20PARTS_small.png",
      url: "/apex-gasket",
    },
  ],
  "HOPKINS FLOTOOL": [
    {
      manufacturer: "HOPKINS MANUFACTURING",
      manufacturerImageLogoUrl: "/images/manufacturers/HOPKINS%20MANUFACTURING_small.png",
      url: "/hopkins-manufacturing",
    },
  ],
};
